<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat>
					<v-card-text class="pb-0 pt-2">
						<v-row class="pb-1">
							<v-col class="d-flex justify-start pa-0 pl-2">
								<v-btn color="primary" @click="addClick" v-if="$myStore.state.user.user_role_id == 1">
									<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
								</v-btn>
							</v-col>
							<v-col class="d-flex justify-center pb-0 pt-0">
								<v-card-title class="text-center pa-2 pb-2 pt-0">
									{{ $t('modules.courses') }}</v-card-title
								>
							</v-col>
							<v-col></v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0 pt-0">
								<TheTable
									:additional-filters="coursesTable.additionalFilters"
									:default-sort="coursesTable.defaultSort"
									:excel="true"
									:fields="coursesTable.headers"
									:header-selection-key="'courses-headers'"
									:height="coursesTable.height"
									:total-records="coursesTable.total"
									:filter-save-key="'courses-filters'"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in coursesTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editClick(props.item.id, true)"
									>
										<td
											v-if="coursesTable.selectedHeaders.includes('code')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.code }}</b>
										</td>
										<td
											v-if="coursesTable.selectedHeaders.includes('name')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.name }}</b>
										</td>
										<td
											v-if="coursesTable.selectedHeaders.includes('department_id')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.department_display }}</b>
										</td>
										<td
											style="text-align: right"
											v-if="coursesTable.selectedHeaders.includes('price')"
											@click="editClick(item.id, false)"
										>
											{{
												item.price != null
													? Number.isInteger(item.price)
														? item.price.toLocaleString('hr') + ',00'
														: /^\d+\.\d{1}$/.test(item.price.toString())
														? item.price.toLocaleString('hr') + '0'
														: item.price.toLocaleString('hr')
													: ''
											}}
										</td>
										<td
											v-if="coursesTable.selectedHeaders.includes('duration_hours')"
											@click="editClick(item.id, false)"
										>
											{{ item.duration_hours }}
										</td>
										<td
											v-if="coursesTable.selectedHeaders.includes('active')"
											@click="editClick(item.id, false)"
										>
											<v-icon v-if="item.active" small>fa-check</v-icon>
										</td>
										<td>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														small
														v-bind="attrs"
														@click="editClick(item.id, true)"
														v-on="on"
													>
														<v-icon small>fa-external-link-alt</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.openInNewTab') }}</span>
											</v-tooltip>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'Courses',
	components: { TheTable },
	data: function () {
		return {
			coursesTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.code'), value: 'code', type: 'string', width: '100px', allowFilter: true },
					{ text: this.$t('fields.name'), value: 'name', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.department'),
						value: 'department_id',
						type: 'multiple|departments',
						allowFilter: true,
					},
					{ text: this.$t('fields.price'), value: 'price', type: '', allowFilter: true, alignRight: true },
					{ text: this.$t('fields.hours'), value: 'duration_hours', type: '', allowFilter: true },
					{
						text: this.$t('fields.active'),
						value: 'active',
						type: 'boolean',
						width: '100px',
						allowFilter: false,
					},
					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [
					{ text: this.$t('fields.price'), value: 'price', type: 'price_range' },
					{ text: this.$t('fields.hours'), value: 'duration_hours', type: 'number_range' },
					{
						text: this.$t('fields.concessionValidityDate'),
						value: 'concession_validity_date',
						type: 'date_range',
					},
				],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'name',
					descending: true,
				},
			},
		};
	},
	methods: {
		addClick() {
			this.$router.push('/courses/0');
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/courses/' + id);
			} else {
				let routeData = this.$router.resolve('/courses/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectHeaders(headers) {
			this.coursesTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.coursesTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'courses',
				request,
				(data, success) => {
					if (success) {
						vm.coursesTable.items = data.items;
						vm.coursesTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.coursesTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'courses',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/courses', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.coursesTable.height = window.innerHeight - 245 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.courses'), href: '/#/courses', disabled: true },
		]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
